/**
 * The Image height/width set from calcuations's after loading into browser
 * -- allows for display of cold images (no size).
 */


var Marionette = require('marionette'),
    PgModeImgWr = require('../../page/pgMode/pagePgMode'),
    UnRenderablePg = require('../../page/unRenderable/unrenderablePg').page,
    PgModeColdPg = require('../../page/overlay/pgModeOverlay/coldPageMode'),
    BaseContainer = require('../baseModeContainer'),
    fvChannel = require('glRadio').channel('FV'),
    UrlPage = require('../../page/url/view'),
    PgModeGosPg = require('../../page/pgMode/pgModeGos/view');


require('jqDragScroller');


var instVars = {
    scaleModel: {}, // always starts blank, needs to render first

    /* From init of options */
    model: null,  // note: not really needed until renderNewPageView but stored for clarity -- the pageModel -- always reset on renderNewPageView
    vChannel: null,
    viewMdsCh: null // now communication proxy from viewer to pages
};

/* Note: the view in the pageMode Region -- the view holds an image view -- dependent on props of the model */
module.exports = Marionette.LayoutView.extend({

    template: require('../modeContainer.hbs'), // should put in base mode container mixin

    /**
     * Only change scale mode to that of doc mode on entry if the page wasn't originally opened in page mode
     */
    initialize: function(options) {

        _.extend( this, BaseContainer, instVars, _.pick(options, 'model', 'vChannel', 'viewMdsCh') );

    },
    serializeData: function() {
        return {
            docOrPg: 'pg'  //TODO: base
        };
    },
    onRender: function() {
        this.unwrap();
        this.$el.dragScoller();
    },
    regions: {
        pageView: '.FV-paneContent' //use to show new view in there w/out override of scale divs -- the old image wrapper
    },
    onSetScaleModel: function(sm) { //scale model can only created post render
        this.scaleModel = sm;
        this.postScaleTypeChange(); //must be done if viewer opened into page mode view
    },
    _getPgViewConstructor: function(pgModel) {

        if ( pgModel.isCold() )
            return PgModeColdPg;

        if ( !pgModel.isRenderable() )
            return UnRenderablePg;

        if ( pgModel.renderUrlViewForDocAndPageMode() )
            return UrlPage; // (Include GOS html )

        return pgModel.isGOS()
            ? PgModeGosPg
            : PgModeImgWr;
            
    },

    renderNewPageView: function( fullPageModel ) {

        this.model = fullPageModel;  // always reset the page model: will override that set in init (this.options)

        this.$el.scrollTop(0).scrollLeft(0); //reset viewport -- allow to see loading indicator

        var pgModel = this.model,
            PageViewConstructor = this._getPgViewConstructor(pgModel),
            pageView = new PageViewConstructor({
                scale: this.scaleModel,
                vChannel: this.vChannel,
                viewMdsCh: this.viewMdsCh,
                model: pgModel // model not really necessary for the container -- instead for the page view
            });

        // Note: first the initial is removed anyway -- have an alternative path of just setting
        this.getRegion('pageView').once('show', function() {
            pgModel.trigger('creRequest');
        }).show(pageView);

    },
    events: {
        // this is for the properties dialog view of the redaction shape --
        // perhaps only fire if flag set and or debounce the callback
        'scroll': function() {
            this.viewMdsCh.trigger('repositionShapeDialog');
        }
    },
    /**
     * Comes from successful image load or scale change model.
     * Will get called twice on first entry ( both called ) -- will have no effect
     * Set the scale first,then change the size elements with the new scale value
     * Don't allow (if cold and the image isn't loaded, don't use the size that wasn't yet set by image load)
     * Called if in pageMode from state controller (same method name in doc mode)
     * Note: now also comes from rotation change
     */
    postScaleChange: function( scale, previousScale, options ) {


        if ( !this.model.isRenderable() )
            return;

        // Check to not scale if view doesn't yet exist
        var currentPgView = this.getRegion('pageView').currentView;
        if ( ! currentPgView )
            return;


        if ( options && options.fromRotation ) {

            currentPgView.rotate.apply( currentPgView, arguments );

        } else {

            currentPgView.updateViewPort.apply( currentPgView, arguments );

        }

    },

    /**
     *  Note:
     *  - now filtered and only called for drawable note types.
     *  - no longer creating a canvas if one doesn't exist ( eg if user creates new note -- canvas should always exist )
     *  - central point for canvas creation is now on load of the page
     *  - find and redact drawing mode may be different -- eg: want 'grab'; change to always render canvas
     *    should help facilitate ( if already created, just trigger 're-render' shapes equivalent )
     *    - will prob not want to call this toggle active note, it will no longer have anything to do with find & redact
     *     unless why utilize the change activePage outline
     *  - Now that canvas always created; may want to put in DOM first before shapes are to simplify canvas creation WF due
     *   to errors with Raphael text having to be in DOM.
     */
    toggleDrawingMode: function(pgNote, options) {

        var pgRegion = this.getRegion('pageView');

        if (pgNote) {

            pgRegion.$el.removeClass('grab');
            this.$el.destroyDragScroller();

        } else {

            pgRegion.$el.addClass('grab');
            this.$el.dragScoller();
        }

        // Note: this will take action on the page and then re-render the shapes on the canvas
        // If the page hasn't yet loaded (eg enter from mode/page change), same logic is applied
        // prior to render of the canvas so this action is not skipped.
        // Separate now for find and redact -- want to re-render shapes.
        this.viewMdsCh.trigger('activeNoteChange', pgNote, options);

    },

    /**
     * Now just handle the disabling grabby hand for 'Best Fit scale';
     * Previously also prevented overflow via CSS.
     */
    postScaleTypeChange: function() {

        var scaleType = this.scaleModel.get('scaleType'),
            grabbyHandApplied = this.$el.data('grabbyHandApplied'); // this should be a state/variable

        if ( this.scaleModel.isBestFit() ) {

            this.$el.destroyDragScroller(); // ( toggles grabbyHandApplied )

        } else {

            !grabbyHandApplied && this.$el.dragScoller();
        }

    },

    onBeforeDestroy: function() {
        this.$el.destroyDragScroller();
    }


});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewModes/pageMode/pgModeContainer.js
 ** module id = 461
 ** module chunks = 0
 **/